<div class="greeting">
    <div class="header">{{ "__COMPONENTS_GREETING__" | translate }} {{userService.userInfo?.first_name}}</div>
    <div class="subheader">{{ "__COMPONENTS_WELCOME_MESSAGE__" | translate }}</div>
</div>
<ng-select class="My-dropdown"
           *ngIf="managers"
           [(ngModel)]="managerId" (ngModelChange)="selectFilter($event)"
           [searchable]="false" [clearable]="false">
    <ng-option [value]="0">{{'__TEAMLIST_MYTEAM__' | translate}}</ng-option>
    <ng-option *ngFor="let manager of managers" [value]="manager.id">
        {{manager.full_name}}
    </ng-option>
</ng-select>
